import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  CircularProgress,
  IconButton,
  Link,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import moment from 'moment';
import { IApplicationAccident } from 'pages/PageApplicationNew/components/ApplicationAccidentDialog/interfaces';
import { getPath as getPageApplicationPath } from 'pages/PageApplication';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons';

const useStyles = makeStyles({
  table: {
    '& thead': {
      '& tr': {
        '& th': {
          backgroundColor: '#F5F5F5',
          fontWeight: 'bold',
        },
      },
    },
  },
});

interface IProps {
  data: { list: IApplicationAccident[]; totalCount: number };
  page: number;
  pageSize: number;
  loading: boolean;
  error: string | null;
  onChangePage(page: number): void;
}

const RealEstateAccidents = ({ data, error, loading, onChangePage, page, pageSize }: IProps) => {
  // Styles
  const classes = useStyles();

  return Boolean(loading) ? (
    <Box sx={{ p: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress />
    </Box>
  ) : Boolean(error) && !Boolean(data) ? (
    <Box p={3}>
      <Typography component="h3" variant="h6" align="center">
        {error}
      </Typography>
    </Box>
  ) : data.list.length ? (
    <TableContainer component={Paper} variant="outlined">
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>
              <b>Тип замечания</b>
            </TableCell>

            <TableCell>
              <b>Дата создания</b>
            </TableCell>

            <TableCell>
              <b>Дата выполнения</b>
            </TableCell>

            <TableCell>
              <b>Номер заявки</b>
            </TableCell>

            <TableCell>
              <b>Статус</b>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data.list.map((accident) => {
            const { applicationNumber, defectTypeName, doneTimestamp, createTimestamp, statusName } = accident;

            return (
              <TableRow key={applicationNumber}>
                <TableCell>{defectTypeName}</TableCell>
                <TableCell>{moment(createTimestamp).format('DD.MM.YYYY')}</TableCell>
                <TableCell>{doneTimestamp ? moment(doneTimestamp).format('DD.MM.YYYY') : '—'}</TableCell>
                <TableCell>
                  <Link
                    target="_blank"
                    component={RouterLink}
                    to={getPageApplicationPath(applicationNumber!)}
                    underline="hover"
                  >
                    {applicationNumber}
                  </Link>
                </TableCell>
                <TableCell>{statusName}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

      <Box sx={{ p: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
        <IconButton aria-label="Назад" disabled={loading || page === 1} onClick={() => onChangePage(page - 1)}>
          <KeyboardArrowLeft />
        </IconButton>

        <IconButton
          aria-label="Вперёд"
          disabled={loading || page === Math.ceil(data.totalCount / pageSize)}
          onClick={() => onChangePage(page + 1)}
        >
          <KeyboardArrowRight />
        </IconButton>
      </Box>
    </TableContainer>
  ) : (
    <Box sx={{ bgcolor: '#fff', borderRadius: 20 }}>
      <Box p={3}>
        <Typography component="h3" variant="h6" align="center">
          Данные отсутствуют
        </Typography>
      </Box>
    </Box>
  );
};

export default RealEstateAccidents;
